mxBasePath = 'assets/mxgraph';
